mxBasePath = 'assets/mxgraph';
